import schedule from './schedule'
import distribution from './distribution'

export default {
  get: {
    method: 'get',
    url: '/journey/ID'
  },
  getVehicles: {
    method: 'get',
    url: '/journey/vehicles'
  },
  getJourneys: {
    method: 'get',
    url: '/journey/list'
  },
  schedule,
  distribution
}
